import { BKJComboBoxAsync, ErrorBoundary } from '@awais4123/fillify-design-library';
import {
  LocationFilterDataContext,
  LocationFilterDataProvider,
  useLocationFilterDataContext,
} from 'components/LocationFilterInput/LocationFilterInput.context';
import { ILocationFilterProps } from 'components/LocationFilterInput/LocationFilterInput.types';
import i18next from 'i18next';
import { WhiteLabelAccessor } from 'utils/whiteLabelAccessor';
function LocationFilterInputComponent(props: Omit<ILocationFilterProps, 'options'>) {
  const { value, onChange, name = 'location' } = props;
  const { data: options = [], values, onChange: onSearchChange } = useLocationFilterDataContext();

  return (
    <BKJComboBoxAsync
      name={name}
      type="Single"
      value={value}
      searchKey="byName"
      onChange={onChange}
      action="OpenToggle"
      options={options}
      searchValue={values.byName}
      onSearchChange={onSearchChange}
      context={LocationFilterDataContext}
      placeholder={i18next.t('agency_member:SELECT_LOCATIONS')}
    />
  );
}

export const TeamLocationFilterInput = (props: Omit<ILocationFilterProps, 'options'>) => {
  return (
    <ErrorBoundary
      componentName="LocationFilterInput"
      showLogo={!WhiteLabelAccessor.isWhiteLabelled()}
    >
      <LocationFilterDataProvider>
        <LocationFilterInputComponent {...props} />
      </LocationFilterDataProvider>
    </ErrorBoundary>
  );
};
